import Phone from './phone';
import Email from './email';

export default {
    Phone,
    Email
}